var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H8.00001C7.45001 0 7.00001 0.45 7.00001 1C7.00001 1.55 7.45001 2 8.00001 2H12C12.55 2 13 1.55 13 1C13 0.45 12.55 0 12 0ZM10 13C10.55 13 11 12.55 11 12V8C11 7.45 10.55 7 10 7C9.45001 7 9.00001 7.45 9.00001 8V12C9.00001 12.55 9.45001 13 10 13ZM17.03 6.39L17.78 5.64C18.16 5.26 18.17 4.63 17.78 4.24L17.77 4.23C17.38 3.84 16.76 3.85 16.37 4.23L15.62 4.98C14.07 3.74 12.12 3 10 3C5.20001 3 1.12001 6.96 1.00001 11.76C0.870009 16.84 4.94001 21 10 21C14.98 21 19 16.97 19 12C19 9.88 18.26 7.93 17.03 6.39ZM10 19C6.13001 19 3.00001 15.87 3.00001 12C3.00001 8.13 6.13001 5 10 5C13.87 5 17 8.13 17 12C17 15.87 13.87 19 10 19Z",
    fill: "#44C032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.32afedc86df94fa7159cd3a567088669.svg";
export { ForwardRef as ReactComponent };